import {CreditCardModel} from './credit-card.model';

export function formatCardDetails(card: CreditCardModel) {
  return card
    ? card.first_six_digits + ' ** **** ' + card.last_four_digits + ' ' + card.expiration_month + '/' + card.expiration_year
    : '';
}
